export default {
  in_queue: {
    name: 'В очереди'
  },
  cooking: {
    name: 'Готовится'
  },
  packing: {
    name: 'Упаковывается'
  },
  done: {
    name: 'Готово'
  }
}